module.exports = {"activation.modal.content.text":"Bitte warten Sie, während wir Sie anmelden und Ihr Abonnement aktivieren.","activation.modal.content.status":"Aktivieren"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/de/components/ModalContent/Activation.json
// module id = 870
// module chunks = 0